var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfilledStarIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icon/ Unfilled / star-100%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.5174 5.10248C12.7025 4.65762 13.3327 4.65762 13.5177 5.10249L15.4694 9.79498C15.5474 9.98253 15.7238 10.1107 15.9263 10.1269L20.9922 10.533C21.4725 10.5715 21.6672 11.1709 21.3013 11.4843L17.4416 14.7906C17.2873 14.9227 17.22 15.1301 17.2671 15.3277L18.4463 20.2712C18.5581 20.7398 18.0483 21.1102 17.6371 20.8591L13.2999 18.21C13.1266 18.1041 12.9086 18.1041 12.7352 18.21L8.39808 20.8591C7.9869 21.1102 7.47705 20.7398 7.58885 20.2712L8.76805 15.3277C8.81518 15.1301 8.74781 14.9227 8.59355 14.7906L4.73384 11.4843C4.36792 11.1709 4.56266 10.5715 5.04293 10.533L10.1089 10.1269C10.3114 10.1107 10.4877 9.98253 10.5657 9.79498L12.5174 5.10248Z",
    stroke: "#6D7699"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledStarIconSmall);
export default __webpack_public_path__ + "static/media/unfilledStarIconSmall.66015dd5adef986d21a76cd5ece04f51.svg";
export { ForwardRef as ReactComponent };